// Review gallery: every explainer on paper and on indigo, plus a 320px instance.
// Query params (review only): ?only=tag|handover|scan|transfer|erp|claim|forms|parts|sequence  ?freeze=<ms>
import React from 'react';
import { FreezeContext } from './engine';
import { TagExplainer, HandoverExplainer, OwnerScanExplainer, TransferExplainer, ErpSyncExplainer, ClaimExplainer, FormsExplainer, PartsExplainer, HowItWorksSequence } from './index';
import type { ExplainerProps, ExplainerUnit } from './engine';
import { heroUnits } from '../heroUnits';
import { AGRI_UNIT } from './unit';
import { sectorUnits } from '../pages/industries/data';

const ITEMS: { key: string; name: string; C: (p: ExplainerProps) => React.ReactElement }[] = [
  { key: 'tag', name: 'TagExplainer', C: TagExplainer },
  { key: 'handover', name: 'HandoverExplainer', C: HandoverExplainer },
  { key: 'scan', name: 'OwnerScanExplainer', C: OwnerScanExplainer },
  { key: 'transfer', name: 'TransferExplainer', C: TransferExplainer },
  { key: 'erp', name: 'ErpSyncExplainer', C: ErpSyncExplainer },
  { key: 'claim', name: 'ClaimExplainer', C: ClaimExplainer },
  { key: 'forms', name: 'FormsExplainer', C: FormsExplainer },
  { key: 'parts', name: 'PartsExplainer', C: PartsExplainer },
];

export function ExplainerGallery() {
  const q = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const only = q.get('only');
  const fz = q.get('freeze');
  // ?unit=heatpump|mower|oven|ebike|agri tells every explainer's story about that unit.
  const uk = q.get('unit');
  // Also accepts a sector slug (e.g. lifting-access-equipment) for the sector units.
  const unit: ExplainerUnit | undefined = uk === 'agri' ? AGRI_UNIT : (heroUnits.find((h) => h.key === uk) ?? (uk ? sectorUnits[uk] : undefined));
  const freeze = fz !== null ? Number(fz) : undefined;
  const items = ITEMS.filter((i) => !only || i.key === only);
  return (
    <FreezeContext.Provider value={freeze}>
      <main>
        {(!only || only === 'sequence') && (
          <>
            <section className="section" style={{ background: '#fff' }}>
              <div className="wrap">
                <div className="t-eyebrow" style={{ marginBottom: 24 }}>HowItWorksSequence · light</div>
                <HowItWorksSequence unit={unit} />
              </div>
            </section>
            <section className="section on-dark" style={{ background: '#241E61' }}>
              <div className="wrap">
                <div className="t-eyebrow" style={{ marginBottom: 24 }}>HowItWorksSequence · dark</div>
                <HowItWorksSequence tone="dark" unit={unit} />
              </div>
            </section>
          </>
        )}
        {items.map(({ key, name, C }) => (
          <section key={key} style={{ borderTop: '1px solid #E4E3F0' }}>
            <div className="grid md:grid-cols-2">
              <div style={{ background: '#fff', padding: 'clamp(24px,4vw,56px)' }}>
                <div className="t-eyebrow" style={{ marginBottom: 16 }}>{name} · light</div>
                <div style={{ maxWidth: 600 }}>
                  <C unit={unit} />
                </div>
              </div>
              <div className="on-dark" style={{ background: '#241E61', padding: 'clamp(24px,4vw,56px)' }}>
                <div className="t-eyebrow" style={{ marginBottom: 16 }}>{name} · dark</div>
                <div style={{ maxWidth: 600 }}>
                  <C tone="dark" unit={unit} />
                </div>
              </div>
            </div>
            {only && (
              <div style={{ background: '#F7F7FC', padding: 24, display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                <div style={{ width: 320 }}>
                  <C unit={unit} />
                </div>
                <div style={{ width: 320, background: '#241E61', padding: 0 }}>
                  <C tone="dark" autoPlay={false} unit={unit} />
                </div>
              </div>
            )}
          </section>
        ))}
      </main>
    </FreezeContext.Provider>
  );
}
